import { TemplateFormFieldEnum } from '../interfaces/template-form-field';
import { TemplateFormComponentMeta } from '../interfaces/template-form-component-meta';
import { SwitchToggleFieldMeta } from '../components/TemplateFormSwitchToggleField/meta/templateFormSwitchToggleFieldMeta';
import {
  NumberTextFieldMeta,
  TextFieldMeta
} from '../components/TemplateFormTextField/meta/templateFormTextFieldMeta';
import { PasswordFieldMeta } from '../components/TemplateFormPasswordField/meta/templateFormPasswordFieldMeta';
import { SSHFieldMeta } from '../components/TemplateFormSSHConfigField/meta/templateFormSSHConfigFieldMeta';
import { SSLFieldMeta } from '../components/TemplateFormSSLConfigField/meta/templateFormSSLConfigFieldMeta';
import { TemplateNameFieldMeta } from '../components/TemplateFormNameField/meta/templateFormNameFieldMeta';
import { RadioGroupFieldMeta } from '../components/TemplateFormRadioGroupField/meta/radioGroupFieldMeta';
import { TemplateFormDropdownFieldMeta } from '../components/TemplateFormDropdownField/meta/templateFormDropdownFieldMeta';
import { TemplateFormAuthorizationButtonFieldMeta } from '../components/TemplateFormAuthorizationButtonField/meta/templateFormAuthorizationButtonFieldMeta';
import { TemplateLiteralValueFieldMeta } from '../components/TemplateFormLiteralValueField/meta/TemplateLiteralValueFieldMeta';
import { TemplateFormFilePickerFieldMeta } from '../components/TemplateFormFilePickerField/meta/templateFormFilePickerFieldMeta';

export const TEMPLATE_FORM_FIELD_REGISTRY: Record<
  TemplateFormFieldEnum,
  TemplateFormComponentMeta
> = {
  [TemplateFormFieldEnum.BOOLEAN]: SwitchToggleFieldMeta,
  [TemplateFormFieldEnum.TOGGLE]: SwitchToggleFieldMeta,
  [TemplateFormFieldEnum.STRING]: TextFieldMeta,
  [TemplateFormFieldEnum.LONG]: NumberTextFieldMeta,
  [TemplateFormFieldEnum.PASSWORD]: PasswordFieldMeta,
  [TemplateFormFieldEnum.SSH]: SSHFieldMeta, // component
  [TemplateFormFieldEnum.SSL]: SSLFieldMeta, // component
  [TemplateFormFieldEnum.SOURCE_NAME]: TemplateNameFieldMeta, // component
  [TemplateFormFieldEnum.DESTINATION_NAME]: TemplateNameFieldMeta, // component
  [TemplateFormFieldEnum.DROPDOWN]: TemplateFormDropdownFieldMeta, // component
  [TemplateFormFieldEnum.RADIO_GROUP]: RadioGroupFieldMeta,
  [TemplateFormFieldEnum.AUTHORIZATION_BUTTON]: TemplateFormAuthorizationButtonFieldMeta, // component
  [TemplateFormFieldEnum.SYSTEM_GENERATED]: TemplateLiteralValueFieldMeta, // component
  [TemplateFormFieldEnum.FILE_PICKER]: TemplateFormFilePickerFieldMeta // component
};
